<template>
  <div id="app">
    <Header />
    <Banner />
    <!-- <Submission /> -->
    <Loading
      v-if="false"
    />
    <router-view v-show="true" class="view"/>
    <Footer v-show="true" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
const Loading = () => import('@/components/Loading/Page')
const Header = () => import('@/components/Header/Main')
const Banner = () => import('@/components/Banner/Main')
// const Submission = () => import('@/components/Submission/Main')
const Footer = () => import('@/components/Footer/Main')

export default {
  components: {
    Loading,
    Header,
    Banner,
    // Submission,
    Footer
  },

  computed: {
    ...mapState({
      loadBanner: state => state.banner.isLoading,
      loadSponsor: state => state.sponsor.isLoading
    })
  },

  watch: {
    '$route' () {
      window.scrollTo(0, 0)
      this.$store.dispatch('banner/get', this.$route.name)
    }
  }
}
</script>

<style lang="scss">
.view {
  // animation: opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
